import { Utils } from '@/utilities/Utils';
import { FormTagsPlugin } from 'bootstrap-vue';

export interface IBookingVM {
    id: number;
    guid: string;
    statusID: number;
    status: string;
    contractorID: number;
    contractorAdminID: number;
    worksPostCode: string;
    worksLatitude: number;
    worksLongitude: number;
    worksWhatThreeWords: string;
    worksPlaceName: string;
    description: string;
    firstStay: Date;
    lastStay: Date;
    isDayStay: boolean;
    totalDays: number;
    latestArrivalDefault: Date;
    foodAllowance: number;
    parkingRequirements: string;
    additionalComments: string;
    defaultNightsPerStay: number;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    hasDefaultLatestArrival: boolean;
    isDisabled: boolean;
    confirmDisabled: boolean;
    datesDisabled: boolean;
    scanInEarliestDifference: number;
    scanInLatestDifference: number;
    scanOutEarliestDifference: number;
    scanOutLatestDifference: number;
    scanDefaultStayDuration: number;
    bookingSummaryVisible: boolean;
    firstOrLastStayInThePast: boolean;
    scanReportVisible: boolean;
    costCodeID: number;
    isBookingOnly: boolean;
    hasPreferredHotel: boolean;
    contractorHotelNotes: string;
    preferredHotelName: string;
}

export class BookingVM implements IBookingVM {

    constructor(data?: IBookingVM) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IBookingVM) {
        Utils.clone(data, this);
    }

    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    statusID: number = 0;
    status: string = "";
    contractorID: number = 0;
    contractorAdminID: number = 0;
    worksPostCode: string = "";
    worksLatitude: number = 0;
    worksLongitude: number = 0;
    worksPlaceName: string = "";
    worksWhatThreeWords: string = "";
    description: string = "";
    firstStay: Date = new Date(Utils.emptyDateValue);
    lastStay: Date = new Date(Utils.emptyDateValue);
    isDayStay: boolean = false;
    totalDays: number = 0;
    latestArrivalDefault: Date = new Date();
    foodAllowance: number = 0;
    parkingRequirements: string = "";
    additionalComments: string = "";
    currentUserAssigned: boolean = false;
    defaultNightsPerStay: number = 0;
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    hasDefaultLatestArrival: boolean = false;
    isDisabled: boolean = false;
    confirmDisabled: boolean = false;
    datesDisabled: boolean = false;
    scanInEarliestDifference: number = 0;
    scanInLatestDifference: number = 0;
    scanOutEarliestDifference: number = 0;
    scanOutLatestDifference: number = 0;
    scanDefaultStayDuration: number = 0;
    bookingSummaryVisible: boolean = false;
    firstOrLastStayInThePast: boolean = false;
    scanReportVisible: boolean = false;
    costCodeID: number = 0;
    isBookingOnly: boolean = false;
    hasPreferredHotel: boolean = false;
    contractorHotelNotes: string = "";
    preferredHotelName: string = "";

    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    get latLng() {
        return `[${this.worksLatitude}, ${this.worksLongitude}]`;
    }

    get w3w() {
        return `///${this.worksWhatThreeWords}`;
    }

    get bookingDurationDescription() {
        return new Intl.DateTimeFormat("en-GB").format(this.firstStay) + ' - ' + new Intl.DateTimeFormat("en-GB").format(this.lastStay);
    }

    get latestArrivalDefaultTime() {
        if (this.latestArrivalDefault == null) {
             this.latestArrivalDefault = new Date();
        }
        const hours = this.latestArrivalDefault.getHours().toString().length > 1 ? this.latestArrivalDefault.getHours() : "0" + this.latestArrivalDefault.getHours();
        const mins = this.latestArrivalDefault.getMinutes().toString().length > 1 ? this.latestArrivalDefault.getMinutes() : "0" + this.latestArrivalDefault.getMinutes();
        return hours + ":" + mins;
    }

    set latestArrivalDefaultTime(val: string) {

        const parts = val.split(":");
        const time = new Date();

        time.setHours(+parts[0]);
        time.setMinutes(+parts[1]);
        time.setSeconds(0);

        this.latestArrivalDefault = time;
    }

    get canEditFirstStay() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return this.firstStay < today;
    }

    get canEditLastStay() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        return this.lastStay < today;
    }

    get visibleFirstStay() {
        if (!this.firstStay) return this.firstStay;
        return this.firstStay.toLocaleDateString("en-uk", { weekday: 'short' }) +
            " " +
            this.firstStay.getDate() +
            " " +
            this.firstStay.toLocaleDateString("en-uk", { month: 'short' });
    }

    get visibleLastStay() {
        if (!this.lastStay) return this.lastStay;

        return this.lastStay.toLocaleDateString("en-uk", { weekday: 'short' }) +
            " " +
            this.lastStay.getDate() +
            " " +
            this.lastStay.toLocaleDateString("en-uk", { month: 'short' });
    }
}